import { render, staticRenderFns } from "./AddExclude.vue?vue&type=template&id=3b42bb9e&"
import script from "./AddExclude.vue?vue&type=script&lang=js&"
export * from "./AddExclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports